import React from 'react';
import { PageContent } from '~/__modules__/page';
import { UnknownMessage } from '~/__modules__/error';

export default function UnknownScene() {
  return (
    <PageContent empty={true}>
      <UnknownMessage />
    </PageContent>
  );
}
